module.exports = __webpack_public_path__ + "media/images/riders/MYRIAM_NICOLE-8dddd5dd7215e7dc5611793a26e0426e.png";